var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonCicsProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1275 14.8662L13.185 16.8087L14.25 17.8662L17.25 14.8662L14.25 11.8662L13.185 12.9237L15.1275 14.8662ZM8.8725 14.8662L10.815 12.9237L9.75 11.8662L6.75 14.8662L9.75 17.8662L10.815 16.8087L8.8725 14.8662Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.36621C7.16421 7.36621 7.5 7.03042 7.5 6.61621C7.5 6.202 7.16421 5.86621 6.75 5.86621C6.33579 5.86621 6 6.202 6 6.61621C6 7.03042 6.33579 7.36621 6.75 7.36621Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.36621C4.91421 7.36621 5.25 7.03042 5.25 6.61621C5.25 6.202 4.91421 5.86621 4.5 5.86621C4.08579 5.86621 3.75 6.202 3.75 6.61621C3.75 7.03042 4.08579 7.36621 4.5 7.36621Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.61621H3C2.17275 3.61621 1.5 4.28971 1.5 5.11621V20.1162C1.5 20.9435 2.17275 21.6162 3 21.6162H21C21.8272 21.6162 22.5 20.9435 22.5 20.1162V5.11621C22.5 4.28971 21.8272 3.61621 21 3.61621ZM21 5.11621V8.11621H3V5.11621H21ZM3 20.1162V9.61621H21V20.1162H3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCicsProgram);
export default __webpack_public_path__ + "static/media/carbon_cics-program.0afa1a263c5989b536de8801fb647568.svg";
export { ForwardRef as ReactComponent };